<template>
  <!-- FOOTER OPEN -->
  <footer class="demo-footer footer-institutionnel">

    <!-- TOP FOOTER -->
    <div class="container py-6">
      <div class="row gy-4">

        <!-- ACTUALITÉS -->
        <div class="col-lg-2 col-md-4">
          <h6 class="footer-title">ACTUALITÉS</h6>
          <ul class="footer-links">
            <li><router-link to="/actualites">Communiqués</router-link></li>
            <li><router-link to="/publications">Rapports</router-link></li>
            <li><router-link to="/actualites">Points de presse</router-link></li>
          </ul>
        </div>

        <!-- MÉDIATHÈQUE -->
        <div class="col-lg-2 col-md-4">
          <h6 class="footer-title">MÉDIATHÈQUE</h6>
          <ul class="footer-links">
            <li><router-link to="/finances-publiques">Finances publiques</router-link></li>
            <li><router-link to="/textes-et-lois">Textes & lois</router-link></li>
          </ul>
        </div>

        <!-- LE MINISTÈRE -->
        <div class="col-lg-2 col-md-4">
          <h6 class="footer-title">LA CNTIPPEE</h6>
          <ul class="footer-links">
            <li><router-link to="/a-propos">Présentation</router-link></li>
            <li><router-link to="/decret">Décret de création</router-link></li>
            <li><router-link to="/organisation">Organisation</router-link></li>
          </ul>
        </div>

        <!-- SUIVEZ-NOUS -->
        <div class="col-lg-2 col-md-6">
          <h6 class="footer-title">SUIVEZ-NOUS</h6>
          <div class="footer-social">
            <a href="#" aria-label="Twitter"><i class="fa fa-twitter"></i></a>
            <a href="#" aria-label="Facebook"><i class="fa fa-facebook"></i></a>
            <a href="#" aria-label="YouTube"><i class="fa fa-youtube"></i></a>
            <a href="#" aria-label="LinkedIn"><i class="fa fa-linkedin"></i></a>
          </div>
        </div>

        <!-- SERVICES -->
        <div class="col-lg-4 col-md-6">
          <h6 class="footer-title">SERVICES</h6>

          <ul class="footer-services">
            <li>
              <i class="fe fe-file-text"></i>
              Attestation d’affiliation au FNRB
            </li>
            <li>
              <i class="fe fe-edit"></i>
              Agrément de change manuel
            </li>
            <li>
              <i class="fe fe-refresh-ccw"></i>
              Autorisation de change
            </li>
            <li>
              <i class="fe fe-users"></i>
              Autorisation de change – personnes morales
            </li>
          </ul>
        </div>

      </div>
    </div>

    <!-- LIENS LÉGAUX -->
    <div class="footer-links-bar">
      <div class="container d-flex flex-wrap justify-content-between">
        <div class="footer-bottom-links">
          <router-link to="/mentions-legales">Mentions légales</router-link>
          <router-link to="/confidentialite">Politique de confidentialité</router-link>
          <router-link to="/contact">Contact</router-link>
        </div>

        <router-link to="/plaintes" class="footer-plainte">
          Plaintes & suggestions
        </router-link>
      </div>
    </div>

    <!-- BORDURE GABON -->
    <div class="border-gabon"></div>

    <!-- COPYRIGHT -->
    <div class="footer-copyright text-center">
      © {{ year }} <strong>CNTIPPEE</strong> – République Gabonaise. Tous droits réservés.
    </div>


  </footer>
  <!-- FOOTER CLOSED -->
</template>

<script>
  export default {
    name: "LandingFooter",
    computed: {
      year() {
        return new Date().getFullYear();
      }
    }
  };
</script>

<style scoped>

.border-gabon {
  width: 100%;
  height: 5px;
  background: linear-gradient(
      to right,
      #009e60 0%,
      #009e60 33.33%,
      #fcd116 33.33%,
      #fcd116 66.66%,
      #3a75c4 66.66%,
      #3a75c4 100%
  );
}

.footer-copyright {
  padding: 1rem 0;
  font-size: 0.9rem;
  color: #6c757d;
  background: #f8f9fb;
}

.footer-institutionnel {
  background: #f8f9fb;
  border-top: 1px solid #e5e7eb;
}

.footer-title {
  font-weight: 700;
  font-size: 13px;
  letter-spacing: .5px;
  margin-bottom: 1rem;
  color: #0f172a;
}

.footer-links,
.footer-services {
  list-style: none;
  padding: 0;
  margin: 0;
}

.footer-links li,
.footer-services li {
  margin-bottom: .5rem;
  font-size: 14px;
}

.footer-links a {
  color: #475569;
}

.footer-links a:hover {
  color: #6366f1;
}

.footer-services i {
  margin-right: .5rem;
  color: #6366f1;
}

.footer-social a {
  display: inline-flex;
  width: 36px;
  height: 36px;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background: #e5e7eb;
  color: #0f172a;
  margin-right: .5rem;
}

.footer-links-bar {
  border-top: 1px solid #e5e7eb;
  padding: 1rem 0;
  font-size: 14px;
}

.footer-bottom-links a {
  margin-right: 1rem;
  color: #475569;
}

.footer-plainte {
  font-weight: 600;
  color: #6366f1;
}

.footer-copyright {
  background: #eef0f5;
  padding: 1rem;
  font-size: 13px;
}

</style>